"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentState = void 0;
const moment_1 = __importDefault(require("moment"));
const ComponentType_1 = require("./ComponentType");
const Awning_1 = require("./Awning");
const Battery_1 = require("./Battery");
const HVAC_1 = require("./HVAC");
const Inverter_1 = require("./Inverter");
const Light_1 = require("./Light");
const Mode_1 = require("./Mode");
const VentFan_1 = require("./VentFan");
const WindowShade_1 = require("./WindowShade");
const InternalComponentType_1 = require("./InternalComponentType");
const Skylight_1 = require("./Skylight");
class ComponentState {
    constructor(config) {
        this.idMap = new Map();
        this.internalIdMap = new Map();
        this.configJson = config;
        this.trailerConfig = JSON.parse(config);
        this.updatedAt = moment_1.default(this.trailerConfig.updatedAt);
        this.populateComponents();
    }
    populateComponents() {
        this.trailerConfig.components.forEach(component => {
            let componentToAdd;
            let iidType;
            switch (component.type) {
                case ComponentType_1.ComponentType.LIGHT:
                    componentToAdd = Light_1.Light.fromConfig(component);
                    iidType = InternalComponentType_1.InternalComponentType.Circuit;
                    break;
                default:
                    return;
            }
            this.idMap.set(component.id, componentToAdd);
            component.iid.forEach(iid => {
                this.internalIdMap.set(`${iidType}/${iid}`, componentToAdd);
            });
        });
    }
    getComponentById(id) {
        return this.idMap.get(id);
    }
    getComponentByInternalId(type, internalId) {
        return this.internalIdMap.get(`${type}/${internalId}`);
    }
    getComponents() {
        return this.idMap.values();
    }
    getUpdatedAt() {
        return this.updatedAt;
    }
    static createPayloadForAction({ type, action, currentState, values, }) {
        switch (type) {
            case ComponentType_1.ComponentType.AWNING:
                return Awning_1.Awning[action]({ currentState, values });
            case ComponentType_1.ComponentType.BATTERY:
                return Battery_1.Battery[action]({ currentState, values });
            case ComponentType_1.ComponentType.HVAC:
                return HVAC_1.HVAC[action]({ currentState, values });
            case ComponentType_1.ComponentType.INVERTER:
                return Inverter_1.Inverter[action]({ currentState, values });
            case ComponentType_1.ComponentType.LIGHT:
                return Light_1.Light[action]({ currentState, values });
            case ComponentType_1.ComponentType.MODE:
                return Mode_1.Mode[action]({ currentState, values });
            case ComponentType_1.ComponentType.VENT_FAN:
                return VentFan_1.VentFan[action]({ currentState, values });
            case ComponentType_1.ComponentType.WINDOW_SHADE:
                return WindowShade_1.WindowShade[action]({ currentState, values });
            case ComponentType_1.ComponentType.SKYLIGHT:
                return Skylight_1.Skylight[action]({ currentState, values });
            default:
        }
        return {};
    }
}
exports.ComponentState = ComponentState;
//# sourceMappingURL=ComponentState.js.map